import React, { useEffect } from "react";
import { Routes, Route, Navigate, Link } from "react-router-dom";
import "./styles.css";
import TroopsFormation from "../../screens/troops-formation";
import ArenaHomeLayout from "../../layouts/arena-layout";
import Camp from "../camp";
import CampLayout from "../../layouts/camp-layout";
import ArenaDashboard from "../dashboard";
import FriendlyMatchBox from "./friendly-match";
import MatchSuggestion from "./match-suggestion";
import BattleField from "../battle-field";
import JoinBattle from "./join-battle";
import ArenaLeaderBoard from "../../screens/leader-board";
import LiveBattleIframe from "../../screens/live-iframe";
import useUserData from "../../../hooks/useUserData";
import Button from "../../../components/Button";
import WatchScreen from "../../screens/watch";
import DefaultLayout from "../../../layouts/DefaultLayout";

type Props = {};

const ArenaNavigator = (props: Props) => {
  const {} = useUserData();
  return (
    <>
      <div className="arena-container">
        {/* {
          <div
            style={{
              top: 0,
              right: 0,
              position: "fixed",
              zIndex: 45000,
              backdropFilter: "blur(10px)",
              backgroundColor: "rgba(0,0,0,0.6)",
            }}
            className="d-flex w-100 h-100 justify-content-center align-items-center fs-big text-white flex-column gap-2"
          >
            <img
              src={"/assets/images/under-maintenance.png"}
              width={200}
              height={200}
            />
            Under Maintenance
            <br />
            <Link to={"/home"}>
              <Button className="" variant="wide">
                Back Home
              </Button>
            </Link>
          </div>
        } */}
        {/* { !IsBeta && windowSize.width < 768 && <ComingSoon />} */}
        <Routes>
          <Route path="/live-battle" element={<BattleField />} />
          <Route path="/formation" element={<TroopsFormation />} />
          <Route path="/live" element={<LiveBattleIframe />} />
          {/* <Route path="/camp" element={<CampLayout />}>
            <Route index element={<Camp />} />
          </Route> */}
          {/* <Route path="/" element={<DefaultLayout />}>
            <Route path="/watch" element={<WatchScreen />} />
            <Route path="/host-match" element={<FriendlyMatchBox />} />
            <Route path="/join-match" element={<JoinBattle />} />
            <Route path="/leader-board/:type" element={<ArenaLeaderBoard />} />
            <Route
              path="/leader-board"
              element={<Navigate to="/arena/leader-board/lords" />}
            />
            <Route
              path="/battle-lobby"
              element={<MatchSuggestion timeout={30000} isJoinMatch={false} />}
            />
          
          </Route> */}
            <Route path="*" element={<Navigate to="/home" />} />
        </Routes>
      </div>
    </>
  );
};

export default ArenaNavigator;
